import { fetchAemArticlesData } from "@/services/aem";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

type ArticalAEMlayout = {
  recipescategories: any[] | null;
  loading: boolean;
  sideBar: any;
  banner: any;
  data: any;
  buttonText: string;
};

const initialState: ArticalAEMlayout = {
  recipescategories: [],
  loading: false,
  sideBar: {},
  banner: {},
  data: {},
  buttonText: "",
};
const AemArticledataSlice = createSlice({
  name: "aemSearchResults",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAemArticleData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAemArticleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.banner =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ]?.[":items"]?.["columncontrol"]?.[":items"]?.["column-2"]?.[
            ":items"
          ];
        state.recipescategories =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ][":items"]["columncontrol"][":items"]["column-2"][":items"][
            "recipescategories"
          ]["recipesCategoriesList"];
        state.sideBar =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ][":items"]["columncontrol"][":items"]["column-1"][":items"][
            "sortandfilter"
          ];
        state.buttonText =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ]?.[":items"]?.["columncontrol"]?.[":items"]?.["column-2"]?.[
            ":items"
          ]?.button?.text;
      });
  },
});

export const fetchAemArticleData = createAsyncThunk(
  `content/empire/${(process.env.NEXT_PUBLIC_DEFAULT_BANNER ?? "").toLowerCase()}/en/articles.model.json`,
  async () => {
    const articalAEMlayout = await fetchAemArticlesData();

    return articalAEMlayout;
  }
);

export default AemArticledataSlice.reducer;
